"use client"
import styled from "@emotion/styled"
import { Button, Modal, Typography } from "@mui/material"
import Image from "next/image"
import { MouseEvent, useState } from "react"

const ImageContainer = styled.div`
  border-radius: 16px;
  border: 2px solid var(--Grey-Gray-M, #d1d5db);
  position: relative;
  width: 100%;
  height: 240px;
  overflow: hidden;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 675px;
    height: 494px;
  }
`

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
  z-index: 10000000;
`

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
  position: relative;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 40px;
    width: unset;
  }
`
const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(2, 11, 8, 0.8);
  z-index: -1;
`

const CloseButton = styled(Button)`
  position: absolute;
  z-index: 100000000;
  top: 0;
  left: 0;
  ${(props) => props.theme.breakpoints.up("md")} {
    left: -182px;
  }

  min-width: 0;
  min-height: 0;
  height: fit-content;
  padding: 0 !important;
`

type NextImageProps = React.ComponentProps<typeof Image>

function CustomImage({
  src,
  alt,
  height,
  width,
  fill,
  style,
  ...props
}: NextImageProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => setIsOpen(true)
  const handleClose = () => setIsOpen(false)

  return (
    <>
      <Image
        {...props}
        style={{ ...style, cursor: "pointer" }}
        onClick={handleOpen}
        src={src}
        alt={alt}
        width={width}
        height={height}
        fill={fill}
      />
      {isOpen && (
        <StyledModal open={isOpen} component={"div"} onClick={handleClose}>
          <>
            <Content onClick={(e) => e.stopPropagation()}>
              <ImageContainer>
                <Image src={src} alt={alt} fill objectFit="cover" />
              </ImageContainer>

              <CloseButton
                onClick={(e: MouseEvent<HTMLButtonElement, MouseEvent>) => {
                  e.stopPropagation()
                  handleClose()
                }}
              >
                <Image
                  src={"/icons/closeGallery.svg"}
                  height={40}
                  width={40}
                  alt=""
                />
              </CloseButton>
              {alt && (
                <Typography variant="body1" fontWeight={700} color="white">
                  {alt}
                </Typography>
              )}
            </Content>
            <Backdrop />
          </>
        </StyledModal>
      )}
    </>
  )
}

export default CustomImage
